import { ViRouteType } from '../enums/vi-route-type.enum';
import { ParamMap } from '@angular/router';

export class ViRouteModel {
    type: ViRouteType;
    value?: number;
    queryParamMap?: ParamMap;

    constructor(type: ViRouteType, value?: string, queryParamMap?: ParamMap) {

        this.type = type;
        if (value) {
            this.value = +value;
        }
        this.queryParamMap = queryParamMap;
    }
}
